/***************************************************************************************
 * FileName      : LoadingModal.tsx
 * Description   : 로딩 중 상태 표시 모달
 * Author        : (주)한국공학기술연구원 박은정
 * Created Date  : 2026.02.13
 * Modified Date : 2026.02.20
 * Reference     : 
 ***************************************************************************************/

import React from 'react';

interface Props {
  isVisible: boolean;
}

// 2026.02.13 : 박은정 : 로딩 중 상태 표시 모달 컴포넌트 추가
// 2026.02.20 : 박은정 : 3D 공간 로딩 시 배경 이미지 표시 (background-image로 다운로드 방지)
// 2026.02.20 : 박은정 : 로딩 모달 카드 배경 제거, 배경 이미지 위에 로딩 표시 직접 배치
export const LoadingModal: React.FC<Props> = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="loading-modal loading-modal--visible">
      {/* 2026.02.20 : 박은정 : 배경 이미지 (background-image로 적용하여 이미지 다운로드 방지) */}
      <div
        className="loading-modal__backdrop loading-modal__backdrop--bg"
        style={{ backgroundImage: `url('assets/image/loding-background-img.png')` }}
      />

      {/* 2026.02.20 : 박은정 : 로딩 표시 — 카드 배경 제거, 배경 이미지 바로 위에 표시 */}
      <div className="loading-modal__indicator">
        {/* 로딩 스피너 */}
        <div className="loading-modal__spinner">
          <svg className="loading-modal__spinner-svg" viewBox="0 0 50 50">
            {/* 2026.02.20 : 박은정 : 흰색 테두리용 배경 원 (두꺼운 흰색 stroke) */}
            <circle
              className="loading-modal__spinner-outline"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              strokeWidth="7"
            />
            {/* 2026.02.20 : 박은정 : 주색 스피너 원 (테두리 위에 겹침) */}
            <circle
              className="loading-modal__spinner-circle"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              strokeWidth="5"
            />
          </svg>
        </div>

        {/* 로딩 텍스트 */}
        <p className="loading-modal__text">3D 공간을 불러오는 중...</p>
      </div>
    </div>
  );
};

